import React from 'react';

import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import DashboardLayout from "./business/containers/DashboardLayout";
import { useKeycloak } from '@react-keycloak/web'
import ORMLayout from "./containers/ORMLayout";
import NavigationAnnouncerComponent from "./components/NavigationAnnouncerComponent";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


const App = () => {
    const { initialized, keycloak } = useKeycloak()

    if (!initialized) {
        return <div>Loading...</div>
    }

    /**
     * ⚠ These are internal routes!
     * They will be rendered inside the app, using the default `containers/Layout`.
     * If you want to add a route to, let's say, a landing page, you should add
     * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
     * are routed.
     *
     * If you're looking for the links rendered in the SidebarContent, go to
     * `routes/sidebar.js`
     */
    return (
        <Router>
            <FontAwesomeIcon icon="fa-file-chart-column" />
            <NavigationAnnouncerComponent />
            <Routes>
                <Route path="/" element={<Navigate replace to="/dashboard" />} />
                {/* eslint-disable-next-line no-restricted-globals */}
                {/*Error is that it says props is undefined*/}
                <Route path="/dashboard/*"
                       exact={true}
                       index element={<DashboardLayout />}/>

                <Route path="/orm" Component={ORMLayout} />
            </Routes>
        </Router >
    )
};




export default App;